import { DfeInventoryTotal } from '@/lib/api';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Hash } from 'lucide-react';

interface ItemInstancesDialogProps {
  /** an NFT the user owns more than one of */
  item: DfeInventoryTotal | null;
  open: boolean;
  onClose: () => void;
  /** the instance the user picked — its own page has Transfer and Burn */
  onChoose: (itemId: string) => void;
}

/**
 * The instances behind one inventory card: each NFT instance is its own item
 * (its own number and metadata), so the card that counts them hands the
 * choice of one to the user.
 */
export function ItemInstancesDialog({ item, open, onClose, onChoose }: ItemInstancesDialogProps) {
  const listed = item?.instances ?? [];
  const more = item ? Math.max(0, item.quantity - listed.length) : 0;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{item?.name}</DialogTitle>
          <DialogDescription>
            You own {item?.quantity.toLocaleString()}. Choose one to view, transfer or burn it.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 py-2 max-h-80 overflow-y-auto">
          {listed.map((instance) => (
            <Button
              key={instance.itemId}
              variant="outline"
              size="sm"
              onClick={() => onChoose(instance.itemId)}
              aria-label={`${item?.name} #${instance.instanceNumber}`}
            >
              <Hash className="h-3 w-3 mr-0.5" />
              {instance.instanceNumber}
            </Button>
          ))}
        </div>
        {more > 0 && (
          <p className="text-sm text-muted-foreground">and {more.toLocaleString()} more</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
